export default __webpack_public_path__ + "media/images/features/jtb/hero-line-04d14224274fbaed8bd1302d3bc0bf13.png";